import { graphql } from "gatsby";
import { RadioButtonsBasic } from "../../../../src/examples/components/RadioButtons";
import * as React from 'react';
export default {
  graphql,
  RadioButtonsBasic,
  React
};